import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { Loggedincontext } from './Loggedincontext.js';
import { Routedispatcherprovider } from './Routedispatcher';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './trans.css';
import Welcome from './components/Welcomefiles/Welcome';
import { fetchuseauthorization } from './components/API/Login_API';
import PrintComponent from './components/Dashboard/Ordersfiles/PrintComponent.js';
import BarcodePrint from './components/Dashboard/Productsfiles/BarcodePrint.js';
import Login from './components/Dashboard/Login/Login.js';
import Pagepreloader from './components/Dashboard/Pagepreloader.js';
import { IoMdClose } from 'react-icons/io';
import { Modal } from 'react-bootstrap';
import AIChat from './components/Dashboard/AIChat/AIChat.js';
import { isAiAllowedInstitute } from './components/Dashboard/AIChat/aiAllowedInstitutes';
import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from './firebase';
import { serverbaselink } from './Env_Variables.js';
import audioSound from './components/Dashboard/Generalfiles/sounds/siren_sms.mp3';
import axios from 'axios';
import Buttonpreloader from './components/Dashboard/Buttonpreloader';
import { useMobileKeyboardLayout } from './mobileViewport';

const Dashboardrouter = React.lazy(() => import('./components/Dashboard/Dashboardrouter'));

const App = (props) => {
    const [nointernetconnection, setnointernetconnection] = useState(false);
    window.addEventListener('offline', function (e) {
        setnointernetconnection(true);
    });

    window.addEventListener('online', function (e) {
        setnointernetconnection(false);
    });
    useMobileKeyboardLayout();
    let history = useHistory();
    const {
        userloggedinfobjcontext,
        setuserloggedinfobjcontext,
        isloggedincontext,
        setisloggedincontext,
        useraccesspagescontext,
        setuseraccesspagescontext,
        surveyModalOpenContext,
        setsurveyModalOpenContext,
    } = React.useContext(Loggedincontext);
    const fetchuseauthorizationQuery = useQuery(['fetchuseauthorization'], () => fetchuseauthorization(), { keepPreviousData: true, staleTime: 500000000000000000 });
    // useEffect(() => {
    // }, []);
    useEffect(() => {
        async function initNotifications() {
            const permission = await Notification.requestPermission();

            if (permission !== 'granted') return;
            var cmpr = 'BAslMlii03UuHOduMVYLNBxskg5Y-MfQ8XZkPv3LfRjKtvpuGlvoC2SwftwUuak_8ScBhC4iECr9pTzOAs500yw';
            const token = await getToken(messaging, {
                vapidKey: cmpr,
            });

            console.log(token);

            // // Send token to Laravel
            // await fetch("/api/fcm-token", {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //         "Authorization": `Bearer ${token}`
            //     },
            //     body: JSON.stringify({
            //         fcm_token: token
            //     })
            // });
            try {
                const response = await axios.post(
                    serverbaselink + '/instowner/wbp',
                    {
                        token,
                    },
                    {
                        withCredentials: true,
                    },
                );

                // const data = response.data;
            } catch (e) {
                console.error(e);
            }
        }

        initNotifications();
    }, []);

    onMessage(messaging, (payload) => {
        console.log(payload);

        const playAudio = () => {
            const audio = new Audio(audioSound);
            audio.play().catch((error) => {
                console.error('Error playing audio:', error);
            });
        };
        playAudio();

        // Show the notification (only if you're handling foreground notifications yourself)
        if (Notification.permission === 'granted') {
            new Notification(payload.notification.title, {
                body: payload.notification.body,
                icon: payload.notification?.icon,
            });
        }
    });
    useEffect(() => {
        if (fetchuseauthorizationQuery.isSuccess) {
            setisloggedincontext(fetchuseauthorizationQuery.data.data.loggedin);
            if (fetchuseauthorizationQuery.data.data.loggedin) {
                var tempuserloggedinfo = { ...userloggedinfobjcontext };
                tempuserloggedinfo.userinfo = { ...fetchuseauthorizationQuery.data.data.userinfo };
                tempuserloggedinfo.currentinstinfo = { ...fetchuseauthorizationQuery.data.data.instinfo };
                tempuserloggedinfo.dmn = fetchuseauthorizationQuery.data.data.dmn;
                if (fetchuseauthorizationQuery.data.data.inst_should_fill_survey_form == true) {
                    setsurveyModalOpenContext(true);
                }
                setuserloggedinfobjcontext({
                    ...tempuserloggedinfo,
                });
                if (Array.isArray(fetchuseauthorizationQuery.data.data.userpagepermissions)) {
                    setuseraccesspagescontext([...fetchuseauthorizationQuery.data.data.userpagepermissions]);
                } else {
                    setuseraccesspagescontext([]);
                }
            } else {
                // window.location.href = 'https://tabex-co.com';
            }
        }
    }, [fetchuseauthorizationQuery.isSuccess, fetchuseauthorizationQuery?.data, fetchuseauthorizationQuery?.data?.data?.instinfo?.russian_lang]);

    return (
        <Router>
            <Routedispatcherprovider>
                <div style={{ height: '100%', width: '100%' }}>
                    <Suspense fallback={<Pagepreloader fullPage />}>
                        {fetchuseauthorizationQuery?.isSuccess &&
                            fetchuseauthorizationQuery?.data?.data?.loggedin &&
                            isAiAllowedInstitute(fetchuseauthorizationQuery?.data?.data?.instinfo?.instid) &&
                            isloggedincontext == true && <AIChat />}

                        <Route
                            render={({ location, match }) => {
                                return (
                                    <div>
                                        {nointernetconnection && (
                                            <div
                                                class="w-100 text-center h-100 d-flex mx-auto justify-content-center"
                                                style={{
                                                    backgroundColor: 'white',
                                                    position: 'fixed',
                                                    height: '100%',
                                                    zIndex: 99999999999,
                                                    color: 'red',
                                                    opacity: 0.5,
                                                    alignContent: 'center',
                                                    justifyContent: 'center',
                                                    verticalAlign: 'center',
                                                    fontSize: '25px',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                <div class="text-center  mt-auto mb-auto m-auto align-items-center d-flex">
                                                    Trying To Connect To The Internet...
                                                    <Buttonpreloader variant="onLight" size={30} />
                                                </div>
                                            </div>
                                        )}
                                        <TransitionGroup>
                                            <CSSTransition in={match != null} key={location.key} timeout={300} classNames="page" unmountOnExit>
                                                <Switch key={location.key} location={location}>
                                                    <Route
                                                        exact
                                                        path="/"
                                                        render={() => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <Redirect to="/dashboard/institute" />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/login"
                                                        render={() => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <Redirect to="/dashboard/institute" />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/dashboard"
                                                        render={() => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <Redirect to="/dashboard/institute" />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        path="/dashboard/institute"
                                                        render={() => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <Dashboardrouter />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        path="/dashboard/printcomponent/:orderidparams"
                                                        render={() => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <PrintComponent />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        path="/dashboard/barcodeprint"
                                                        render={() => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <BarcodePrint />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />

                                                    <Route
                                                        path="/dashboard/welcome"
                                                        render={(props) => {
                                                            if (fetchuseauthorizationQuery.isSuccess) {
                                                                if (isloggedincontext == true) {
                                                                    return <Welcome />;
                                                                } else {
                                                                    return <Login />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Switch>
                                            </CSSTransition>
                                        </TransitionGroup>
                                    </div>
                                );
                            }}
                        />
                    </Suspense>
                </div>
            </Routedispatcherprovider>
        </Router>
    );
};

export default App;
